import { createIcon } from '@chakra-ui/react';

export const PlayIcon = createIcon({
  displayName: 'PlayIcon',
  viewBox: '0 0 35 35',
  path: [
    <circle key="1" cx="17.5" cy="17.5" r="17.5" fill="white" />,
    <path
      key="2"
      d="M11 22.2196V11.7806C11 9.56001 13.3927 8.23855 15.1733 9.47491L22.8124 14.7779C24.4101 15.8874 24.3925 18.3269 22.7793 19.4113L15.1403 24.5478C13.357 25.7467 11 24.4215 11 22.2196Z"
      fill="#FF5000"
    />
  ]
});
